import React from 'react';
import { X } from 'lucide-react';
import { SKETCHPLAN_PRICING_COPY, SKETCHPLAN_VAT } from '@rehub/pricing';
import DirectCardPricingTable from './DirectCardPricingTable';

interface PricingBenefitsModalProps {
  onClose: () => void;
  onSignUp?: () => void;
  onOrder?: () => void;
  showCredits?: boolean;
}

const PricingBenefitsModal: React.FC<PricingBenefitsModalProps> = ({ onClose, onOrder, showCredits = false }) => {
  return (
    <div
      className="fixed inset-0 bg-black/85 backdrop-blur-sm flex items-center justify-center z-[60] p-4 overflow-y-auto"
      onClick={onClose}
    >
      <div
        className="bg-slate-900 border border-slate-700 rounded-2xl shadow-2xl w-full max-w-3xl my-8 max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sticky top-0 bg-slate-900/95 backdrop-blur border-b border-slate-700 px-6 py-4 z-10 flex items-start justify-between gap-4">
          <div>
            <h2 className="text-xl font-bold text-white">Sketchplan pricing</h2>
            <p className="text-sm text-slate-400 mt-0.5">
              Fixed prices by property size. {SKETCHPLAN_PRICING_COPY.deliveryStandard}. {SKETCHPLAN_PRICING_COPY.amendment}
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="p-2 rounded-lg text-slate-400 hover:text-white hover:bg-slate-800"
            aria-label="Close"
          >
            <X size={22} />
          </button>
        </div>
        <div className="px-6 py-5 space-y-5">
          <DirectCardPricingTable onOrder={onOrder} />
          <p className="text-sm text-slate-400">{SKETCHPLAN_PRICING_COPY.amendmentLong}</p>
          <p className="text-sm text-slate-400">{SKETCHPLAN_PRICING_COPY.noLogin}</p>
          <p className="text-xs text-slate-500">{SKETCHPLAN_VAT.summary}</p>
          {showCredits && (
            <p className="text-xs text-slate-500">
              Logged-in clients can still settle with ReHub credits at the matching cash price. Credit packs stay inside your account.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PricingBenefitsModal;
